import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom, customAvatarAtom } from '../../State';
import { ReactComponent as AddAvatarSVG } from '../Images/buttons/addAvatarButton.svg';
import { ReactComponent as DotCircleSVG } from '../Images/buttons/dotCircle.svg';
import 'react-loading-skeleton/dist/skeleton.css';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import NFTItem from './NFTItem';
import NFTMyCustomItem from './NFTMyCustomItem';
import NFTMyCustomUpload from './NFTMyCustom_old';
import EditDetail from './EditDetail';
import EditAvatar from './EditAvatar';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default function NFTMyCustom({ setNftType, setEditState, editState }) {
  //Recoil系
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [customAvatarState, setCustomAvatarState] = useRecoilState(customAvatarAtom);

  //その他
  const [loadingState, setLoadingState] = useState(false);
  //const [uploadingState, setUploadingState] = useState(null);
  const [avatarsState, setAvatarsState] = useState(null);
  const [selectedArray, setSelectedArray] = useState([]); //選択中のスタイル
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [myCustomAvatar, setMyCustomAvatar] = useState(null);
  const [baseNameState, setBaseNameState] = useState(null);
  const inputFileRef = useRef(null);
  const { t } = useTranslation();

  //初期化
  useEffect(() => {
    //作成済みのカスタムアバターの存在チェック
    getMyCustomAvatar();
  }, []);

  async function getMyCustomAvatar() {
    const result = await DataModel.getMyCustomAvatar();

    if (result != null) {
      if (result.patternID != null) {
        setMyCustomAvatar(result.patternID);
      }
    } else {
      setMyCustomAvatar(null);
    }
  }

  //NFTアイテムをタップ時
  const selectItem = async (baseName) => {
    if (baseName == 'test') {
      return;
    }
    setBaseNameState(baseName);
    setEditState('detail');
  };

  //画像のローディング完了トリガー
  const loadCompleted = async () => {
    setLoadingState(true);
  };

  //戻るタップ
  const tapBackArrow = () => {
    setEditState(null);
    //空欄に
    setCustomAvatarState({});

    //マイアバター取得
    getMyCustomAvatar();
  };

  return (
    <>
      <div id="myAvatarWrap">
        {/* スタイル選択 */}
        {editState == null && (
          <>
            <div className="nftTitleEach">{t('nft.Recently created')}</div>
            <div
              className="myAvatarList"
              style={{ height: '80px', gridTemplateColumns: '20% 20% 22% 22%' }}>
              {myCustomAvatar != null ? (
                <>
                  <NFTItem
                    imageURL={'timeless'}
                    thumbURL={'images/nft/thumb/timeless.png'}
                    type={'pro'}
                    nftID={myCustomAvatar}
                    showType="partnerList"
                    limit="anyone"
                    nftName=""
                  />
                </>
              ) : (
                <>
                  <div className="no2Dme">
                    <DotCircleSVG />
                  </div>

                  {/* <NFTItem
                    imageURL={'timeless'}
                    thumbURL={'images/nft/thumb/timeless.png'}
                    type={'pro'}
                    nftID={'defaultkun'}
                    showType="partnerList"
                    limit="anyone"
                    nftName=""
                  /> */}
                </>
              )}
              <>
                {/* <div className="no2Dme"></div> */}
                <NFTItem
                  imageURL={'timeless'}
                  thumbURL={'images/nft/thumb/timeless.png'}
                  type={'pro'}
                  nftID={'defaultkun'}
                  showType="partnerList"
                  limit="anyone"
                  nftName=""
                />
              </>

              {/* <div className="myAvatarAddWrap" onClick={() => setNftType('customUpload')}>
                <AddAvatarSVG />
              </div> */}
            </div>

            <div className="nftTitleEach">{t('nft.New style')}</div>

            <Swiper
              slidesPerView={'auto'}
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              pagination={{
                clickable: true,
              }}
              className="mySwiper">
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner1.png'}
                  onClick={() => selectItem('base3')}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner2.png'}
                  onClick={() => selectItem('base23')}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner3.png'}
                  onClick={() => selectItem('base12')}
                />
              </SwiperSlide>
            </Swiper>

            <div className="nftTitleEach">{t('nft.Pick Up')}</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base1'} selectItem={() => selectItem('base1')} />
              <NFTMyCustomItem baseName={'base4'} selectItem={() => selectItem('base4')} />
              <NFTMyCustomItem baseName={'base21'} selectItem={() => selectItem('base21')} />
            </div>

            <div className="nftTitleEach">アニメスタイル</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base10'} selectItem={() => selectItem('base10')} />
              <NFTMyCustomItem baseName={'base17'} selectItem={() => selectItem('base17')} />
              <NFTMyCustomItem baseName={'base2'} selectItem={() => selectItem('base2')} />
            </div>

            <div className="nftTitleEach">モダン</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base5'} selectItem={() => selectItem('base5')} />
              <NFTMyCustomItem baseName={'base23'} selectItem={() => selectItem('base23')} />
              <NFTMyCustomItem baseName={'base6'} selectItem={() => selectItem('base6')} />
            </div>

            <div className="nftTitleEach">What is style?</div>
            <div className="nftBannerExplan">
              <div className="nftBannerLeft">
                <img src={getImagePath() + '/styles/banners/bannerDetail.png'} />
              </div>
              <div className="nftBannerRight">
                <div className="nftBannerTitle">Styles</div>
                <div className="nftBannerBody">
                  In “Styles”, you can customize each traits <a>See detail</a>
                </div>
              </div>
            </div>

            <div className="nftTitleEach">スタイリッシュ</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base11'} selectItem={() => selectItem('base11')} />
              <NFTMyCustomItem baseName={'base13'} selectItem={() => selectItem('base13')} />
              <NFTMyCustomItem baseName={'base9'} selectItem={() => selectItem('base9')} />
            </div>

            <div className="nftTitleEach">アニマル</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base18'} selectItem={() => selectItem('base18')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base19')} />
              <NFTMyCustomItem baseName={'base22'} selectItem={() => selectItem('base22')} />
            </div>

            <div className="nftTitleEach">スタイリッシュ</div>

            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base12'} selectItem={() => selectItem('base12')} />
              <NFTMyCustomItem baseName={'base14'} selectItem={() => selectItem('base14')} />
              <NFTMyCustomItem baseName={'base15'} selectItem={() => selectItem('base15')} />
            </div>

            <div className="nftTitleEach">Popular</div>

            <Swiper
              slidesPerView={'auto'}
              spaceBetween={30}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={true}
              modules={[Autoplay, Navigation]}
              pagination={{
                clickable: true,
              }}
              className="mySwiper">
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner4.png'}
                  onClick={() => selectItem('base21')}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner5.png'}
                  onClick={() => selectItem('base17')}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={getImagePath() + '/styles/banners/banner6.png'}
                  onClick={() => selectItem('base5')}
                />
              </SwiperSlide>
            </Swiper>

            <div className="nftTitleEach">{t('nft.Simple')}</div>
            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base8'} selectItem={() => selectItem('base8')} />
              <NFTMyCustomItem baseName={'base16'} selectItem={() => selectItem('base16')} />
              <NFTMyCustomItem baseName={'base7'} selectItem={() => selectItem('base7')} />
            </div>

            <div className="nftTitleEach">Testing</div>
            <div className="myAvatarList">
              <NFTMyCustomItem baseName={'base3'} selectItem={() => selectItem('base3')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base20')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base24')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base25')} />
              <NFTMyCustomItem baseName={'base20'} selectItem={() => selectItem('base26')} />

              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base27')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base30')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base34')} />
              <NFTMyCustomItem baseName={'base19'} selectItem={() => selectItem('base28')} />
            </div>
          </>
        )}

        {editState == 'detail' && (
          <>
            <div style={{ padding: '0 20px 20px 20px' }}>
              <EditDetail baseName={baseNameState} tapBackArrow={tapBackArrow} />
            </div>
          </>
        )}
      </div>
    </>
  );
}
